import React from 'react';
import { ButtonContainer } from './ThreeDVisualizer.style';

interface ThreeDButtonProps {
  onClick: () => void;
  active?: boolean;
}

const ThreeDButton: React.FC<ThreeDButtonProps> = ({ onClick, active = false }) => {
  return (
    <ButtonContainer onClick={onClick} $active={active}>
      3D
    </ButtonContainer>
  );
};

export default ThreeDButton;
